export default function About() {
  return (
    <section id="about" className="py-24 bg-slate-900">
      <div className="max-w-7xl mx-auto px-8">
        <div className="grid grid-cols-1 lg:grid-cols-2 gap-16 items-center">
          {/* Left Content */}
          <div className="space-y-6">
            <div className="inline-block">
              <span className="text-teal-400 text-sm font-medium tracking-wider uppercase">About KENZAI d.o.o.</span>
            </div>
            
            <h2 className="text-5xl font-bold text-white leading-tight">
              Expert Team<br />
              Building Modern<br />
              iOS Solutions
            </h2>

            <div className="space-y-4 text-slate-300 leading-relaxed">
              <p className="text-lg">
                KENZAI d.o.o. is a dedicated team of experts specializing in developing modern applications for the iOS platform. Our mission is to create innovative solutions that enhance user experience and improve the security of mobile devices.
              </p>
              <p className="text-lg">
                Our flagship products, including VPN and Cleaner, are meticulously designed with user privacy and device performance in mind. We combine cutting-edge technology with intuitive design to deliver applications that users can trust and rely on daily.
              </p>
              <p className="text-lg">
                With a focus on quality, security, and user satisfaction, we continuously innovate to stay ahead in the rapidly evolving mobile application landscape.
              </p>
            </div>

            {/* Stats */}
            <div className="grid grid-cols-3 gap-8 pt-8">
              <div className="space-y-2">
                <div className="text-4xl font-bold text-teal-400">2+</div>
                <div className="text-sm text-slate-400">Products</div>
              </div>
              <div className="space-y-2">
                <div className="text-4xl font-bold text-teal-400">100%</div>
                <div className="text-sm text-slate-400">iOS Focus</div>
              </div>
              <div className="space-y-2">
                <div className="text-4xl font-bold text-teal-400">24/7</div>
                <div className="text-sm text-slate-400">Support</div>
              </div>
            </div>
          </div>

          {/* Right Visual */}
          <div className="relative">
            <div className="relative rounded-3xl overflow-hidden shadow-2xl">
              <img 
                src="https://public.readdy.ai/ai/img_res/21a8898e279ff0c03f516b15d4902de1.jpg"
                alt="KENZAI d.o.o. Development Team"
                className="w-full h-full object-cover"
              />
              {/* Overlay Gradient */}
              <div className="absolute inset-0 bg-gradient-to-t from-slate-900/60 to-transparent"></div>
            </div>
            
            {/* Glow Effect */}
            <div className="absolute inset-0 bg-gradient-to-br from-teal-500/20 to-cyan-500/20 rounded-3xl blur-3xl -z-10"></div>
          </div>
        </div>
      </div>
    </section>
  );
}